import { useMemo, useState } from "react"
import { useDispatch } from "react-redux"
import { APPLICATION_MODE_NEW, CanadaProvinceList } from "../../../../app/constants"
import { combineAddress } from "../../../../app/utils"
import { Button, LineSeperator } from "../../../../components/RegularComponents"
import { saveBusinessLicenceApplicationData } from "../../../../redux/slice/businessLicenceApplicationSlice"
import { setPrimaryAgencyProperty } from "../../../../redux/slice/primaryAgencyApplicationSlice"
import { InformationDetailPanelSection } from "../InformationDetailPanelSection"

export const TrustAccountTab = (props) => {
    const { appData, applicationType } = props
    
    const [sectionToEdit,setSectionToEdit] = useState([]);
    const dispatch = useDispatch()
    
    const handleClick = (section) => {
        let data

        if(section in appData?.trustAccountInstitution) {
            data = appData?.trustAccountInstitution[section]
        }

        if(typeof data !== "undefined") {
            let newSectionEditObj = {...sectionToEdit}
            Object.defineProperty(newSectionEditObj,section,{value: data, enumerable: true, writable: true})
            setSectionToEdit(newSectionEditObj)
        }
    }

    const handleSave = (section) => {

        if(section in appData?.trustAccountInstitution) {
            let modifiedObj = {...appData.trustAccountInstitution}
            modifiedObj[section] = sectionToEdit[section]

            dispatch(setPrimaryAgencyProperty({
                key: "trustAccountInstitution",
                value : modifiedObj,
            }))
        }

        dispatch(saveBusinessLicenceApplicationData(applicationType, APPLICATION_MODE_NEW))
            .then(data => {
                // save successful
                let newSectionEditObj = {...sectionToEdit}
                delete newSectionEditObj[section]
                setSectionToEdit(newSectionEditObj)
            })
            .catch(err => {
                // save error
            })
    }

    const inputEditForm = (sectionKey) => {
        const value = sectionToEdit[sectionKey]
        
        const onChange = (changedValue) => {
            setSectionToEdit(Object.defineProperty({...sectionToEdit}, 
                sectionKey, 
                {value : changedValue, writable: true, enumerable: true})
            )
        }

        return (
            <fieldset className={"ns-fieldset"} id="edit-form">
                <div className="ns-fieldset row bottomMarginNormal">
                    <input
                        className="fw-25 ns-input"
                        type="text"
                        id="edit-form"
                        name="edit-form"
                        value={value}
                        onChange={(e) => {
                            onChange(e.target.value)
                        }}
                    />
                </div>
            </fieldset>
        )
    }

    const provinceOptionElements = useMemo(() => {
        return Object.keys(CanadaProvinceList).map((key) => {
          const element = CanadaProvinceList[key];
          return (
            <option key={key} value={element}>
              {element}
            </option>
          );
        });
      }, []);
      
    const editAddressForm = (sectionKey) => {

        let businessAddress = sectionToEdit[sectionKey]
        const onChange = (property, value) => {
            
            let updatedAddress = {...sectionToEdit[sectionKey]}
            Object.defineProperty(updatedAddress, property, {value : value, writable: true, enumerable: true})

            let updatedSectionToEdit = {...sectionToEdit}
            Object.defineProperty(updatedSectionToEdit, sectionKey, {
                value : updatedAddress, 
                writable: true, 
                enumerable: true
            })
            setSectionToEdit(updatedSectionToEdit)
        }

        return (
            <fieldset className={"ns-fieldset"} id="business-address-edit-form">
                <div className="ns-fieldset row bottomMarginNormal">
                    <label
                        className="ns-label"
                        autoComplete="street-address"
                        htmlFor="businessAddressStreetEdit">
                            Street Address
                    </label>
                    <textarea
                        className="fw-25 ns-input"
                        type="text"
                        id="businessAddressStreetEdit"
                        rows={4} 
                        cols={60}
                        name="city"
                        onChange={e => onChange("singleLineAddress", e.target.value)}>
                            {businessAddress["singleLineAddress"]}
                    </textarea>
                </div>
                <div className="ns-fieldset row bottomMarginNormal">
                    <label for="businessAddressCityEdit">City</label>
                    <input
                        className="fw-25 ns-input"
                        type="text"
                        id="businessAddressCityEdit"
                        name="city"
                        value={businessAddress["city"]}
                        onChange={e => onChange("city", e.target.value)} />
                </div>
                <div className="ns-fieldset row bottomMarginNormal">
                    <label
                        id={"mra-province-select-label"}
                        className="ns-label"
                        htmlFor={"mra-province-select-input"}
                    >
                        Province
                    </label>
                    <div className="select fw-25 inlineDisplay">
                        <select
                        style={{ width: "25em" }}
                        id={"mra-province-select-input"}
                        name={"mra-province-select-input"}
                        value={businessAddress["province"] ?? ""}
                        onChange={e => onChange("province", e.target.value)}
                        >
                        {provinceOptionElements}
                        </select>
                    </div>
                </div>
                <div className="ns-fieldset row">
                    <label htmlFor="businessAddressPINEdit">Postal Code</label>
                    <input
                        type="text"
                        className="fw-25"
                        id="businessAddressPINEdit"
                        name="pin"
                        value={businessAddress["postalCode"]}
                        onChange={e => onChange("postalCode", e.target.value)} 
                    />
                </div>
            </fieldset>
        )
    }

    /* 
    <DetailSection header={"Trademark name"} value={appData.companyTrademark ?? ""} />
    <LineSeperator />
    */

    const signingOfficers = () => (<div style={{display: "flex", flexDirection: "column"}}>
        {appData?.trustAccountInstitution?.signingOfficers?.map(officer => {
            return (<div>{`${officer} \n`}</div>)
        })}
    </div>)

    const editSigningOfficers = () => {
        const officers = sectionToEdit["signingOfficers"]

        const onSigningNameChange = (str,index) => {
            let officersUpdated = [...officers]
            officersUpdated.splice(index, 1, str)
            
            let updatedSectionToEdit = {...sectionToEdit}
            Object.defineProperty(updatedSectionToEdit, "signingOfficers", {
                value : officersUpdated, 
                writable: true, 
                enumerable: true
            })
            setSectionToEdit(updatedSectionToEdit)
        }

        return (
        <fieldset className={"ns-fieldset"} id="edit-form">
            {officers.map((officer, index) => {
                return (
                        <div className="ns-fieldset row bottomMarginNormal">
                            <input
                                className="fw-25 ns-input"
                                type="text"
                                id={`edit-form-${index}`}
                                name={`edit-form-${index}`}
                                value={officer}
                                onChange={(e) => {
                                    onSigningNameChange(e.target.value, index)
                                }}
                            />
                        </div>
                    )
                }
            )}
        </fieldset>
        )
    }

    return (
        <>
            <InformationDetailPanelSection 
                header="Financial instituation" 
                value={ ("branchName" in sectionToEdit) ? 
                        inputEditForm("branchName") : 
                            appData?.trustAccountInstitution?.branchName ?? ""
                }>
                {("branchName" in sectionToEdit) ? 
                    <Button 
                        buttonType="regular_success" 
                        text={"Save"} 
                        onClick={() => handleSave("branchName")} 
                    /> : 
                    <Button 
                        buttonType="regular_primary" 
                        text={"Edit"} 
                        onClick={() => handleClick("branchName")} 
                    />
                }
                </InformationDetailPanelSection>
            <LineSeperator />

            <InformationDetailPanelSection 
                header="Branch address" 
                value={sectionToEdit["address"] ? 
                        editAddressForm("address") : 
                            appData?.trustAccountInstitution?.address ? combineAddress(appData?.trustAccountInstitution?.address) : ""
                }>
                {sectionToEdit["address"] ?
                    <Button 
                        buttonType="regular_success" 
                        text={"Save"} 
                        onClick={() => handleSave("address")} 
                    /> : 
                     <Button 
                        buttonType="regular_primary" 
                        text={"Edit"} 
                        onClick={() => handleClick("address")} 
                />}
            </InformationDetailPanelSection>
            <LineSeperator />

            <InformationDetailPanelSection 
                header="Account number" 
                value={("accountNumber" in sectionToEdit) ? 
                        inputEditForm("accountNumber") :
                            appData?.trustAccountInstitution?.accountNumber ?? ""}
            >
            {("accountNumber" in sectionToEdit) ? 
                <Button 
                    buttonType="regular_success" 
                    text={"Save"} 
                    onClick={() => handleSave("accountNumber")} 
                /> : 
                <Button 
                    buttonType="regular_primary" 
                    text={"Edit"} 
                    onClick={() => handleClick("accountNumber")} 
                />
            }
            </InformationDetailPanelSection>
            <LineSeperator />

            <InformationDetailPanelSection 
                header="Name on account" 
                value={("name" in sectionToEdit) ? 
                        inputEditForm("name") :
                            appData?.trustAccountInstitution?.name ?? ""}
            >
            {("name" in sectionToEdit) ? 
                <Button 
                    buttonType="regular_success" 
                    text={"Save"} 
                    onClick={() => handleSave("name")} 
                /> : 
                <Button 
                    buttonType="regular_primary" 
                    text={"Edit"} 
                    onClick={() => handleClick("name")} 
                />
            }
            </InformationDetailPanelSection>
            <LineSeperator />

            <InformationDetailPanelSection 
                header="Signing officers" 
                value={("signingOfficers" in sectionToEdit) ? 
                            editSigningOfficers() : 
                            signingOfficers()} 
            >
            {("signingOfficers" in sectionToEdit) ? 
                <Button 
                    buttonType="regular_success" 
                    text={"Save"} 
                    onClick={() => handleSave("signingOfficers")} 
                /> : 
                <Button 
                    buttonType="regular_primary" 
                    text={"Edit"} 
                    onClick={() => handleClick("signingOfficers")} 
                />

            }
            </InformationDetailPanelSection>
            <LineSeperator />
        </>
    )
}
